module.exports = __webpack_public_path__ + "img/ep_arrow-right.d3a55d18.svg";